import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG Modules
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressBarModule } from 'primeng/progressbar';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { TagModule } from 'primeng/tag';
import { ChipModule } from 'primeng/chip';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';

// Components
import { OnlineRegistrationComponent } from './online-registration.component';

// Services
import { AcademicLevelsService } from '../../../services/AcademicLevels/academic-levels.service';
import { SeriesService } from '../../../services/series/series.service';
import { DepartmentsService } from '../../../services/departments/departments.service';
import { SpecializationService } from '../../../services/specialization/specialization.service';
import { SchoolService } from '../../../services/school/school.service';

@NgModule({
  declarations: [
    OnlineRegistrationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    
    // PrimeNG Modules
    ButtonModule,
    CardModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    CalendarModule,
    FileUploadModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    ToastModule,
    DividerModule,
    TagModule,
    ChipModule,
    RippleModule,
    TooltipModule,
    RadioButtonModule,
    CheckboxModule,
    InputNumberModule,
    InputMaskModule
  ],
  providers: [
    MessageService,
    AcademicLevelsService,
    SeriesService,
    DepartmentsService,
    SpecializationService,
    SchoolService
  ],
  exports: [
    OnlineRegistrationComponent
  ]
})
export class OnlineRegistrationModule { }
